// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9596a311","977":"5ac4869d"}[chunkId] + ".chunk.js";
};